import { Location } from 'history';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';

import { BILLING_PATH, ROOT_PATH } from '../../../constants/paths/internal';

import COLLAPSED_LOGO from '../../../images/logo_collapsed.png';
import { Account } from '../../../meta/types/account';
import { DomainAccount } from '../../../meta/types/user';
import { NavbarStyle } from '../../../styles/Navbar';
import { COLLAPSED_SIDEBAR_WIDTH, EXTENDED_SIDEBAR_WIDTH } from '../../../styles/Sidebar';
import AccountDropdownItem from './AccountDropdownItem';
import { getSkin } from '../../../lib/skin';

type Props = {
  sidebarCollapsed: boolean;
  rootManaging: boolean;
  location: Location<any>;
  account?: DomainAccount;
};

const LOGO_STYLE = {
  background: '#000',
  transition: 'width 0.3s, left 0.3s',
};

const UNUPGRADABLE_ACCOUNTS = [Account.ROOT, Account.ENTERPRISE];

const Navbar = ({ sidebarCollapsed, rootManaging, location, account }: Props) => {
  const isUpgradable = account
    ? UNUPGRADABLE_ACCOUNTS.find(a => a === account.type) === undefined
    : true;

  return (
    <NavbarStyle className="navbar">
      <div className="title">
        <div
          className="navbar-logo content-center"
          style={{
            ...LOGO_STYLE,
            width: sidebarCollapsed ? COLLAPSED_SIDEBAR_WIDTH : EXTENDED_SIDEBAR_WIDTH,
          }}
        >
          <Link
            to={ROOT_PATH}
            style={{ height: '100%' }}
            onClick={e => {
              if (location.pathname === ROOT_PATH) {
                e.preventDefault();
              }
            }}
          >
            <img
              src={sidebarCollapsed ? COLLAPSED_LOGO : getSkin().logo}
              className="logo"
              alt="Logo"
            />
          </Link>
        </div>
      </div>

      <ul className="navbar-nav">
        {!rootManaging && isUpgradable && getSkin().showSubscriptionPlans && (
          <li>
            <Button color="orange" circular content="Upgrade" as={Link} to={BILLING_PATH} />
          </li>
        )}
        <li>
          <AccountDropdownItem />
        </li>
      </ul>
    </NavbarStyle>
  );
};

export default React.memo(Navbar);
